import { useRef } from 'react';

const MIN_DISTANCE = 50;      // px, below this it is a tap, not a swipe
const MAX_VERTICAL_DRIFT = 1; // horizontal travel must beat vertical travel

/**
 * Horizontal swipe on a touch surface. Returns props to spread on the element.
 * Mirrors the arrow keys: swiping left moves forward, as when turning the page
 * of a right-to-left book.
 */
const useSwipe = ({ onSwipeLeft, onSwipeRight }) => {
  const start = useRef(null);

  const onTouchStart = (event) => {
    const touch = event.touches[0];
    start.current = { x: touch.clientX, y: touch.clientY };
  };

  const onTouchEnd = (event) => {
    if (!start.current) return;
    const touch = event.changedTouches[0];
    const dx = touch.clientX - start.current.x;
    const dy = touch.clientY - start.current.y;
    start.current = null;

    // Ignore vertical scrolling and short taps
    if (Math.abs(dx) < MIN_DISTANCE) return;
    if (Math.abs(dx) <= Math.abs(dy) * MAX_VERTICAL_DRIFT) return;

    if (dx < 0) onSwipeLeft();
    else onSwipeRight();
  };

  return { onTouchStart, onTouchEnd };
};

export default useSwipe;
